$(document).ready(function () {
    let dir = "add";

    $("#table-general-discount").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: '/admin/get-general-discount',
        columns: [
            {data: 'discount', name: 'discount'},
            {data: 'initial_date', name: 'initial_date'},
            {data: 'final_date', name: 'final_date'},
        ],
        "columnDefs": [{
            "targets": 3,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status)
                return '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn m-1 button_almadia_reverse ' +
                    'general-discount-edit btn-sm"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></button> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn m-1 btn-' + status.color_clas + ' change-general-discount-status btn-sm"  ' +
                    'data-id ="' + row.id + '"><i class="' + status.icon + '"></i></button>' +

                    button_general_discount_delete(row.status,row.id)

            }
        }]
    });
    const list_general_discounts = $("#table-general-discount").DataTable()

    $("#add-general-discount").on('click', function (e) {
        e.preventDefault()
        $(".item-general-dir").val(dir)
        clearForm()
        $("#modal-general-discount").modal('show')
    })

    $("#table-general-discount tbody").on('click', '.general-discount-edit', function (e) {
        e.preventDefault()
        rowData = list_general_discounts.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            $(".item-general-" + index).val(value);
            if (index == 'lots_without_discount') {
                $('.item-general-lots_without_discount').val(value);
                $('.item-general-lots_without_discount').trigger("chosen:updated");
            }
        })
        $(".item-general-dir").val('edit')
        $("#modal-general-discount").modal('show')
    })

    $("#table-general-discount tbody").on('click','.change-general-discount-status',function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('id',$(this).data('id'))
        sendData(data,'/admin/change-general-discount-status')
    })

    $("#table-general-discount tbody").on('click','.delete-general_discount',function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('id',$(this).data('id'))
        sendData(data,'/admin/delete-general_discount')
    })

    $("#form-general-discount").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendData(data, '/admin/' + $(".item-general-dir").val() + '-general-discount')
    })


    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    $(".loader_").removeClass("loading")
                    if (response.success == "success") {
                        $("#modal-general-discount").modal('hide')
                        $("#table-general-discount").DataTable().ajax.reload();
                        alertSuccess(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function clearForm() {
        $(".item-general-discount").val('')
        $(".item-general-initial_date").val('')
        $(".item-general-final_date").val('')
        $(".item-general-id").val('')
        $('.item-general-lots_without_discount').val('');
        $('.item-general-lots_without_discount').trigger("chosen:updated");
    }

    function button_general_discount_delete(status,id) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-general_discount btn-sm m-1"  ' +
                'data-id ="' + id + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ' ;
        }
        return "";

    }
})
